//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { catchError, lastValueFrom, map, Observable, of, throwError } from 'rxjs';
import { ConfigSystemParams, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from '../config-system/config-system-service';
import { CountryDTO } from 'src/app/core/models/system/mapping/country.dto';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class CountriesService {
  
  public allCountries: CountryDTO[] | undefined;

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private httpClientService  : HttpClientService
  ) { }
    
  public get(): Observable<CountryDTO[]> {
    try {
      return this.httpClientService.get<CountryDTO[]>(environment.eSimApi + eSimApiPaths.Countries);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.CountriesUseAlias, true)) {
        return this.httpClientService.get<CountryDTO[]>(environment.eSimApi + eSimApiPaths.Countries)
        .pipe(
          map(x => x.map(this.idAndDescriptionConverter_CountryAlias))
        );

      } else {
        return this.httpClientService.get<CountryDTO[]>(environment.eSimApi + eSimApiPaths.Countries)
        .pipe(
          map(x => x.map(this.idAndDescriptionConverter_CountryName))
        );
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
    
  public getIdFromCountry(countryName: string): number | undefined {
    try {
      let country: CountryDTO | undefined;
      
      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.CountriesUseAlias, true)) {
        country=this.allCountries?.find(x => x.alias==countryName);

      } else {
        country=this.allCountries?.find(x => x.countryName==countryName);
      }
                   
      return country?.id;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return -1;
    }
  }

  private idAndDescriptionConverter_CountryAlias(country: CountryDTO) {
    return {id: country.id, description: country.alias};
  }

  private idAndDescriptionConverter_CountryName(country: CountryDTO) {
    return {id: country.id, description: country.countryName};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
      
  public refreshCountriesValues() {
    try {
      this.get()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.allCountries=data;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
